import {
  IconArrowRightFill,
  IconXmarkCircleFill,
} from "@daangn/react-monochrome-icon";
import { useEffect, useRef, useState } from "react";

import * as css from "./SearchInput.css";

type SearchInputProps = {
  name?: string;
  size?: "medium" | "large";
  initialValue?: string | null;
  placeholder?: string;
  border?: boolean;
  autoFocus?: boolean;
  disabled?: boolean;
  onChange?: (text: string) => void;
};
const SearchInput: React.FC<SearchInputProps> = ({
  border = true,
  autoFocus,
  size = "medium",
  ...props
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [text, setText] = useState(props.initialValue ?? "");

  useEffect(() => {
    setText(props.initialValue ?? "");
  }, [props.initialValue]);

  return (
    <div className={css.searchInputContainer}>
      <input
        ref={inputRef}
        className={css.searchInput({ border, size })}
        type="search"
        aria-label="검색어 입력"
        placeholder={props.placeholder}
        name={props.name}
        value={text}
        disabled={props.disabled}
        onChange={(e) => {
          setText(e.target.value);
          props.onChange?.(e.target.value);
        }}
        autoFocus={autoFocus}
      />
      {text !== "" && (
        <button
          className={css.searchResetButton}
          type="button"
          disabled={props.disabled}
          aria-label="검색 결과 초기화"
          onClick={() => {
            setText("");
            props.onChange?.("");
            inputRef.current?.focus();
          }}
        >
          <IconXmarkCircleFill
            className={css.searchResetIcon({
              disabled: props.disabled,
            })}
          />
        </button>
      )}
      <button
        type="submit"
        aria-label="검색"
        disabled={props.disabled}
        className={css.searchInputButton}
      >
        <IconArrowRightFill
          className={css.searchInputIcon({
            disabled: props.disabled,
          })}
        />
      </button>
    </div>
  );
};

export default SearchInput;
